import { c as createNonEnumerableProperty$1 } from './create-non-enumerable-property.js';
import { e as errorStackClear } from './error-stack-clear.js';
import { e as errorStackInstallable } from './error-stack-installable.js';

var createNonEnumerableProperty = createNonEnumerableProperty$1;
var clearErrorStack = errorStackClear;
var ERROR_STACK_INSTALLABLE = errorStackInstallable;

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

var errorStackInstall = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};

export { errorStackInstall as e };
